import React from 'react';
import { Navigate } from 'react-router-dom';

import { LoaderContainer } from '../components/Layout/Style/Layout.style';
import { Loader } from '../components';
import { useAuth0 } from '../__mocks__/@auth0/auth0-react';

const PublicRoute = ({ element }: any) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <LoaderContainer>
        <Loader size={30} />
      </LoaderContainer>
    );
  }

  return !isAuthenticated ? element : <Navigate to="/dashboard" replace />;
};

export default PublicRoute;
